import React from 'react';
import {Button, Descriptions, Modal} from 'antd';
import {useQuery} from '@apollo/client';
import {BCP_CHECK_USER_GROUP} from '../graphql/queries/bcpCheckUserGroupQueries';
import {CheckUserGroupDetailResponse} from '../graphql/types/BcpCheckUserGroupTypes';
import {formatTime} from '../utils/timeFormat';

interface BcpCheckUserGroupDetailModalProps {
    visible: boolean;
    groupId?: number;
    onClose: () => void;
}

const BcpCheckUserGroupDetailModal: React.FC<BcpCheckUserGroupDetailModalProps> = ({
    visible,
    groupId,
    onClose,
}) => {
    const {data} = useQuery<CheckUserGroupDetailResponse>(BCP_CHECK_USER_GROUP, {
        variables: {id: groupId},
        skip: !visible || !groupId,
    });

    const record = data?.bcpCheckUserGroup?.data;

    return (
        <Modal
            title="用户组详情"
            open={visible}
            onCancel={onClose}
            footer={<Button onClick={onClose}>关闭</Button>}
            width={560}
        >
            <Descriptions bordered column={1} size="small">
                <Descriptions.Item label="ID">{record?.id}</Descriptions.Item>
                <Descriptions.Item label="用户组名称">{record?.groupName}</Descriptions.Item>
                <Descriptions.Item label="用户列表">
                    {record?.users?.join(', ') || '-'}
                </Descriptions.Item>
                <Descriptions.Item label="备注">{record?.remark}</Descriptions.Item>
                <Descriptions.Item label="创建人">{record?.createUser}</Descriptions.Item>
                <Descriptions.Item label="创建时间">{formatTime(record?.createTime)}</Descriptions.Item>
            </Descriptions>
        </Modal>
    );
};

export default BcpCheckUserGroupDetailModal;
